import React from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import LoadingScreen from '../../components/LoadingScreen';

// Category display names
const categoryTitles = {
  'therapeutics': 'Therapeutics',
  'medical_device': 'Medical Device',
  'diagnostics': 'Diagnostics',
  'digital_health': 'Digital Health',
  'vaccines': 'Vaccines'
};

const CategoryInputPage = () => {
  const { category } = useParams();
  const { loading } = useAuth();
  const navigate = useNavigate();
  
  // Get properly formatted category title
  const categoryTitle = categoryTitles[category] || category;

  if (loading) {
    return <LoadingScreen message="Loading..." />;
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-6">
        <Link to="/products/create" className="text-primary-600 hover:text-primary-700 flex items-center">
          <svg className="w-5 h-5 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
          </svg>
          Back to Product Category Selection
        </Link>
      </div>
      
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Create {categoryTitle} Product</h1>
        <p className="text-gray-600">This feature is coming soon. Currently, only Therapeutics product creation is fully implemented.</p>
      </div>
      
      <div className="bg-white shadow-md rounded-lg overflow-hidden">
        <div className="p-6">
          <div className="flex flex-col items-center justify-center py-12">
            <div className="text-center mb-8">
              <svg className="w-16 h-16 text-primary-500 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
              <h2 className="text-2xl font-semibold text-gray-800 mb-2">Coming Soon</h2>
              <p className="text-gray-600">
                We're currently working on implementing the {categoryTitle} product creation flow.
                <br />Please check back later or use the Therapeutics product flow for now.
              </p>
            </div>
            
            <div className="flex space-x-4">
              <button
                onClick={() => navigate('/products')}
                className="btn-secondary"
              >
                Back to Products
              </button>
              <button
                onClick={() => navigate('/products/create')}
                className="btn-primary"
              >
                Try Another Category
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryInputPage; 